import createIcon from '@/lib/create-icon'
import React from 'react'

export const HelpSVGIcon = createIcon(
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1505_6427)">
      <path
        d="M6.06016 6.50001C6.2169 6.05446 6.52626 5.67875 6.93347 5.43943C7.34067 5.20012 7.81943 5.11264 8.28495 5.19248C8.75047 5.27233 9.17271 5.51436 9.47688 5.8757C9.78106 6.23703 9.94753 6.69436 9.94683 7.16668C9.94683 8.50001 7.94683 9.16668 7.94683 9.16668M8.00016 11.8333H8.00683M14.6668 8.50001C14.6668 12.1819 11.6821 15.1667 8.00016 15.1667C4.31826 15.1667 1.3335 12.1819 1.3335 8.50001C1.3335 4.81811 4.31826 1.83334 8.00016 1.83334C11.6821 1.83334 14.6668 4.81811 14.6668 8.50001Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1505_6427">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>,
)
